"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _multiSelect = require("../../multiSelect.style");
var _reactSelect = require("react-select");
var _Avatar = _interopRequireDefault(require("../../../Avatar"));
var _Checkbox = _interopRequireDefault(require("../../../Checkbox"));
var _Icon = _interopRequireDefault(require("../../../Icon"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const Default = _a => {
  var {
      variant,
      selectAllChecked,
      fit
    } = _a,
    props = __rest(_a, ["variant", "selectAllChecked", "fit"]);
  const calculateInitials = name => {
    let initials = '';
    name.split(' ').forEach((word, index) => {
      if (index < 2) {
        initials += word[0].toUpperCase();
      }
    });
    return initials;
  };
  const isIndeterminate = () => {
    const value = props.getValue();
    if (value.length) {
      return value.length !== props.options.length;
    }
    return false;
  };
  return (0, _jsxRuntime.jsx)(_reactSelect.components.Option, (0, _extends2["default"])({}, props, {
    children: (0, _jsxRuntime.jsxs)(_multiSelect.Components.Avatar.OptionsWrapper, {
      children: [['checkbox', 'avatar', 'svg', 'group'].includes(variant) && props.value !== 'selectAll' && props.value !== 'deselectAll' && (0, _jsxRuntime.jsx)(_Checkbox["default"], {
        checked: props.isSelected,
        id: props.id,
        name: props.id,
        fit: fit,
        disabled: props.isDisabled,
        onChange: () => null
      }), props.value === 'selectAll' && ['checkbox', 'avatar', 'svg', 'group'].includes(variant) && (0, _jsxRuntime.jsx)(_multiSelect.Components.Multi.OptionsWrapper, {
        children: (0, _jsxRuntime.jsx)(_Checkbox["default"], {
          type: "standard",
          id: "id",
          name: "name",
          fit: fit,
          indeterminate: !selectAllChecked && isIndeterminate(),
          checked: selectAllChecked || props.getValue().length,
          onChange: () => null
        })
      }), (variant === 'avatar' || variant === 'group') && props.value !== 'selectAll' && (0, _jsxRuntime.jsx)(_multiSelect.Components.Avatar.AvatarWrapper, {
        children: (0, _jsxRuntime.jsx)(_Avatar["default"], {
          initials: calculateInitials(props.label),
          fit: "small",
          appearance: "color2",
          imagesrc: "",
          hiddentooltip: false,
          info: "Tooltip text"
        })
      }), variant === 'svg' && props.value !== 'selectAll' && (0, _jsxRuntime.jsx)(_multiSelect.Components.DefaultIconWrapper, {
        children: (0, _jsxRuntime.jsx)(_Icon["default"], {
          name: props.data.svg
        })
      }), (0, _jsxRuntime.jsxs)(_multiSelect.Components.Avatar.LabelWrapper, (0, _extends2["default"])({
        variant: variant,
        label: props.label
      }, {
        children: [props.label, (variant === 'avatar' || variant === 'svg') && (0, _jsxRuntime.jsx)(_multiSelect.Components.Avatar.SubLabelWraaper, {
          children: props.svg
        })]
      }))]
    })
  }));
};
var _default = exports["default"] = Default;